module.exports = __webpack_public_path__ + "public/images/social-studies.0a5c6a89d095056e0386b145ddc36a15.png";